import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

export const GetTemplateMappings = async (emailTemplateMappingModel: any) => {
    try {
        const response = await postCall(urlConfig.TemplateMappings, emailTemplateMappingModel);
        return response.data;
    } catch (error) {
        console.error('Error fetching TemplateMappings', error);
        throw error;
    }
};

export const GetEmailTemplateGroup = async (emailTemplateMappingModel: any) => {
    try {
        const response = await postCall(urlConfig.GetTemplateGroup, emailTemplateMappingModel);
        return response.data;
    } catch (error) {
        console.error('Error fetching TemplateGroup', error);
        throw error;
    }
};

export const GetTemplate = async (emailTemplateMappingModel: any) => {
    try {
        const response = await postCall(urlConfig.GetTemplate, emailTemplateMappingModel);
        return response.data;
    } catch (error) {
        console.error('Error fetching Template', error);
        throw error;
    }
};

export const GetFieldData = async (params: any) => {
    try {
        const response = await postCall(urlConfig.GetField,  params );
        return response.data;
    } catch (error) {
        console.error('Error fetching data', error);
        throw error;
    }
};

export const GetEmailTemplateFields = async (params: any) => {
    try {
        const response = await postCall(urlConfig.GetEmailTemplateFields,  params );
        return response.data;
    } catch (error) {
        console.error('Error fetching data', error);
        throw error;
    }
};

export const CreateEmailMapping = async (params: any) => {
    try {
        const response = await postCall(urlConfig.CreateEmailMapping,  params );
        return response.data;
    } catch (error) {
        console.error('Error fetching data', error);
        throw error;
    }
};

export const GetEmailTemplateMappingbyId = async (params: any) => {
    try {
        const response = await postCall(urlConfig.GetEmailTemplateMappingbyId,  params );
        return response.data;
    } catch (error) {
        console.error('Error fetching data', error);
        throw error;
    }
};